import React from 'react';
import Icon from '@ant-design/icons';
import { ReactComponent as IconStaffSvg }  from '../../assets/icons/icon_profile_blue.svg';

const ProfileIcon=(props)=>{
    return <Icon component={() => <IconStaffSvg />} {...props}/>
}

export default ProfileIcon;